
export const cssFiles = [
    "https://snappy.appypie.com/newui/icons/css/fontello.css",
    "https://snappy.appypie.com/newui/css/font.css",
    "https://media.appypie.com/wp/en/css/appyslim.css",
    "https://media.mediadirhub.com/css/bootstrap.min.css",
    "https://media.mediadirhub.com/css/swiper.min.css",
    "/css/headerLibrary.css",
    "/css/ui.css",
    "/css/pages.css"
]

export const jsFiles = [
    "https://media.mediadirhub.com/js/swiper.min.js",
    "/js/custom.js"
]

export const countryCode = [
    {
        name: "",
        dialCode: "none",
        isoCode: "",
        flag: ""
    },
    {
        name: "Afghanistan",
        dialCode: "+93",
        isoCode: "AF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/af.svg"
    },
    {
        name: "Aland Islands",
        dialCode: "+358",
        isoCode: "AX",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ax.svg"
    },
    {
        name: "Albania",
        dialCode: "+355",
        isoCode: "AL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/al.svg"
    },
    {
        name: "Algeria",
        dialCode: "+213",
        isoCode: "DZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/dz.svg"
    },
    {
        name: "American Samoa",
        dialCode: "+1684",
        isoCode: "AS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/as.svg"
    },
    {
        name: "Andorra",
        dialCode: "+376",
        isoCode: "AD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ad.svg"
    },
    {
        name: "Angola",
        dialCode: "+244",
        isoCode: "AO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ao.svg"
    },
    {
        name: "Anguilla",
        dialCode: "+1264",
        isoCode: "AI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ai.svg"
    },
    {
        name: "Antarctica",
        dialCode: "+672",
        isoCode: "AQ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/aq.svg"
    },
    {
        name: "Antigua and Barbuda",
        dialCode: "+1268",
        isoCode: "AG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ag.svg"
    },
    {
        name: "Argentina",
        dialCode: "+54",
        isoCode: "AR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ar.svg"
    },
    {
        name: "Armenia",
        dialCode: "+374",
        isoCode: "AM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/am.svg"
    },
    {
        name: "Aruba",
        dialCode: "+297",
        isoCode: "AW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/aw.svg"
    },
    {
        name: "Ascension Island",
        dialCode: "+247",
        isoCode: "AC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ac.svg"
    },
    {
        name: "Australia",
        dialCode: "+61",
        isoCode: "AU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/au.svg"
    },
    {
        name: "Austria",
        dialCode: "+43",
        isoCode: "AT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/at.svg"
    },
    {
        name: "Azerbaijan",
        dialCode: "+994",
        isoCode: "AZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/az.svg"
    },
    {
        name: "Bahamas",
        dialCode: "+1242",
        isoCode: "BS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bs.svg"
    },
    {
        name: "Bahrain",
        dialCode: "+973",
        isoCode: "BH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bh.svg"
    },
    {
        name: "Bangladesh",
        dialCode: "+880",
        isoCode: "BD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bd.svg"
    },
    {
        name: "Barbados",
        dialCode: "+1246",
        isoCode: "BB",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bb.svg"
    },
    {
        name: "Belarus",
        dialCode: "+375",
        isoCode: "BY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/by.svg"
    },
    {
        name: "Belgium",
        dialCode: "+32",
        isoCode: "BE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/be.svg"
    },
    {
        name: "Belize",
        dialCode: "+501",
        isoCode: "BZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bz.svg"
    },
    {
        name: "Benin",
        dialCode: "+229",
        isoCode: "BJ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bj.svg"
    },
    {
        name: "Bermuda",
        dialCode: "+1441",
        isoCode: "BM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bm.svg"
    },
    {
        name: "Bhutan",
        dialCode: "+975",
        isoCode: "BT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bt.svg"
    },
    {
        name: "Bolivia",
        dialCode: "+591",
        isoCode: "BO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bo.svg"
    },
    {
        name: "Bosnia and Herzegovina",
        dialCode: "+387",
        isoCode: "BA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ba.svg"
    },
    {
        name: "Botswana",
        dialCode: "+267",
        isoCode: "BW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bw.svg"
    },
    {
        name: "Brazil",
        dialCode: "+55",
        isoCode: "BR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/br.svg"
    },
    {
        name: "British Indian Ocean Territory",
        dialCode: "+246",
        isoCode: "IO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/io.svg"
    },
    {
        name: "Brunei Darussalam",
        dialCode: "+673",
        isoCode: "BN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bn.svg"
    },
    {
        name: "Bulgaria",
        dialCode: "+359",
        isoCode: "BG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bg.svg"
    },
    {
        name: "Burkina Faso",
        dialCode: "+226",
        isoCode: "BF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bf.svg"
    },
    {
        name: "Burundi",
        dialCode: "+257",
        isoCode: "BI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bi.svg"
    },
    {
        name: "Cambodia",
        dialCode: "+855",
        isoCode: "KH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kh.svg"
    },
    {
        name: "Cameroon",
        dialCode: "+237",
        isoCode: "CM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cm.svg"
    },
    {
        name: "Canada",
        dialCode: "+1",
        isoCode: "CA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ca.svg"
    },
    {
        name: "Cape Verde",
        dialCode: "+238",
        isoCode: "CV",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cv.svg"
    },
    {
        name: "Cayman Islands",
        dialCode: "+1345",
        isoCode: "KY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ky.svg"
    },
    {
        name: "Central African Republic",
        dialCode: "+236",
        isoCode: "CF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cf.svg"
    },
    {
        name: "Chad",
        dialCode: "+235",
        isoCode: "TD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/td.svg"
    },
    {
        name: "Chile",
        dialCode: "+56",
        isoCode: "CL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cl.svg"
    },
    {
        name: "China",
        dialCode: "+86",
        isoCode: "CN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cn.svg"
    },
    {
        name: "Christmas Island",
        dialCode: "+61",
        isoCode: "CX",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cx.svg"
    },
    {
        name: "Cocos (Keeling) Islands",
        dialCode: "+61",
        isoCode: "CC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cc.svg"
    },
    {
        name: "Colombia",
        dialCode: "+57",
        isoCode: "CO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/co.svg"
    },
    {
        name: "Comoros",
        dialCode: "+269",
        isoCode: "KM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/km.svg"
    },
    {
        name: "Congo",
        dialCode: "+242",
        isoCode: "CG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cg.svg"
    },
    {
        name: "Cook Islands",
        dialCode: "+682",
        isoCode: "CK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ck.svg"
    },
    {
        name: "Costa Rica",
        dialCode: "+506",
        isoCode: "CR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cr.svg"
    },
    {
        name: "Croatia",
        dialCode: "+385",
        isoCode: "HR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/hr.svg"
    },
    {
        name: "Cuba",
        dialCode: "+53",
        isoCode: "CU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cu.svg"
    },
    {
        name: "Cyprus",
        dialCode: "+357",
        isoCode: "CY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cy.svg"
    },
    {
        name: "Czech Republic",
        dialCode: "+420",
        isoCode: "CZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cz.svg"
    },
    {
        name: "Democratic Republic of the Congo",
        dialCode: "+243",
        isoCode: "CD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/cd.svg"
    },
    {
        name: "Denmark",
        dialCode: "+45",
        isoCode: "DK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/dk.svg"
    },
    {
        name: "Djibouti",
        dialCode: "+253",
        isoCode: "DJ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/dj.svg"
    },
    {
        name: "Dominica",
        dialCode: "+1767",
        isoCode: "DM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/dm.svg"
    },
    {
        name: "Dominican Republic",
        dialCode: "+1849",
        isoCode: "DO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/do.svg"
    },
    {
        name: "Ecuador",
        dialCode: "+593",
        isoCode: "EC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ec.svg"
    },
    {
        name: "Egypt",
        dialCode: "+20",
        isoCode: "EG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/eg.svg"
    },
    {
        name: "El Salvador",
        dialCode: "+503",
        isoCode: "SV",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sv.svg"
    },
    {
        name: "Equatorial Guinea",
        dialCode: "+240",
        isoCode: "GQ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gq.svg"
    },
    {
        name: "Eritrea",
        dialCode: "+291",
        isoCode: "ER",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/er.svg"
    },
    {
        name: "Estonia",
        dialCode: "+372",
        isoCode: "EE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ee.svg"
    },
    {
        name: "Eswatini",
        dialCode: "+268",
        isoCode: "SZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sz.svg"
    },
    {
        name: "Ethiopia",
        dialCode: "+251",
        isoCode: "ET",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/et.svg"
    },
    {
        name: "Falkland Islands (Malvinas)",
        dialCode: "+500",
        isoCode: "FK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fk.svg"
    },
    {
        name: "Faroe Islands",
        dialCode: "+298",
        isoCode: "FO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fo.svg"
    },
    {
        name: "Fiji",
        dialCode: "+679",
        isoCode: "FJ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fj.svg"
    },
    {
        name: "Finland",
        dialCode: "+358",
        isoCode: "FI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fi.svg"
    },
    {
        name: "France",
        dialCode: "+33",
        isoCode: "FR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fr.svg"
    },
    {
        name: "French Guiana",
        dialCode: "+594",
        isoCode: "GF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gf.svg"
    },
    {
        name: "French Polynesia",
        dialCode: "+689",
        isoCode: "PF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pf.svg"
    },
    {
        name: "Gabon",
        dialCode: "+241",
        isoCode: "GA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ga.svg"
    },
    {
        name: "Gambia",
        dialCode: "+220",
        isoCode: "GM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gm.svg"
    },
    {
        name: "Georgia",
        dialCode: "+995",
        isoCode: "GE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ge.svg"
    },
    {
        name: "Germany",
        dialCode: "+49",
        isoCode: "DE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/de.svg"
    },
    {
        name: "Ghana",
        dialCode: "+233",
        isoCode: "GH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gh.svg"
    },
    {
        name: "Gibraltar",
        dialCode: "+350",
        isoCode: "GI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gi.svg"
    },
    {
        name: "Greece",
        dialCode: "+30",
        isoCode: "GR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gr.svg"
    },
    {
        name: "Greenland",
        dialCode: "+299",
        isoCode: "GL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gl.svg"
    },
    {
        name: "Grenada",
        dialCode: "+1473",
        isoCode: "GD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gd.svg"
    },
    {
        name: "Guadeloupe",
        dialCode: "+590",
        isoCode: "GP",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gp.svg"
    },
    {
        name: "Guam",
        dialCode: "+1671",
        isoCode: "GU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gu.svg"
    },
    {
        name: "Guatemala",
        dialCode: "+502",
        isoCode: "GT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gt.svg"
    },
    {
        name: "Guernsey",
        dialCode: "+44-1481",
        isoCode: "GG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gg.svg"
    },
    {
        name: "Guinea",
        dialCode: "+224",
        isoCode: "GN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gn.svg"
    },
    {
        name: "Guinea-Bissau",
        dialCode: "+245",
        isoCode: "GW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gw.svg"
    },
    {
        name: "Guyana",
        dialCode: "+592",
        isoCode: "GY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gy.svg"
    },
    {
        name: "Haiti",
        dialCode: "+509",
        isoCode: "HT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ht.svg"
    },
    {
        name: "Holy See (Vatican City State)",
        dialCode: "+379",
        isoCode: "VA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/va.svg"
    },
    {
        name: "Honduras",
        dialCode: "+504",
        isoCode: "HN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/hn.svg"
    },
    {
        name: "Hong Kong",
        dialCode: "+852",
        isoCode: "HK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/hk.svg"
    },
    {
        name: "Hungary",
        dialCode: "+36",
        isoCode: "HU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/hu.svg"
    },
    {
        name: "Iceland",
        dialCode: "+354",
        isoCode: "IS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/is.svg"
    },
    {
        name: "India",
        dialCode: "+91",
        isoCode: "IN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/in.svg"
    },
    {
        name: "Indonesia",
        dialCode: "+62",
        isoCode: "ID",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/id.svg"
    },
    {
        name: "Iran",
        dialCode: "+98",
        isoCode: "IR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ir.svg"
    },
    {
        name: "Iraq",
        dialCode: "+964",
        isoCode: "IQ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/iq.svg"
    },
    {
        name: "Ireland",
        dialCode: "+353",
        isoCode: "IE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ie.svg"
    },
    {
        name: "Isle of Man",
        dialCode: "+44-1624",
        isoCode: "IM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/im.svg"
    },
    {
        name: "Israel",
        dialCode: "+972",
        isoCode: "IL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/il.svg"
    },
    {
        name: "Italy",
        dialCode: "+39",
        isoCode: "IT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/it.svg"
    },
    {
        name: "Ivory Coast / Cote d'Ivoire",
        dialCode: "+225",
        isoCode: "CI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ci.svg"
    },
    {
        name: "Jamaica",
        dialCode: "+1876",
        isoCode: "JM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/jm.svg"
    },
    {
        name: "Japan",
        dialCode: "+81",
        isoCode: "JP",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/jp.svg"
    },
    {
        name: "Jersey",
        dialCode: "+44-1534",
        isoCode: "JE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/je.svg"
    },
    {
        name: "Jordan",
        dialCode: "+962",
        isoCode: "JO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/jo.svg"
    },
    {
        name: "Kazakhstan",
        dialCode: "+77",
        isoCode: "KZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kz.svg"
    },
    {
        name: "Kenya",
        dialCode: "+254",
        isoCode: "KE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ke.svg"
    },
    {
        name: "Kiribati",
        dialCode: "+686",
        isoCode: "KI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ki.svg"
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        dialCode: "+850",
        isoCode: "KP",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kp.svg"
    },
    {
        name: "Korea, Republic of South Korea",
        dialCode: "+82",
        isoCode: "KR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kr.svg"
    },
    {
        name: "Kosovo",
        dialCode: "+383",
        isoCode: "XK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/xk.svg"
    },
    {
        name: "Kuwait",
        dialCode: "+965",
        isoCode: "KW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kw.svg"
    },
    {
        name: "Kyrgyzstan",
        dialCode: "+996",
        isoCode: "KG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kg.svg"
    },
    {
        name: "Laos",
        dialCode: "+856",
        isoCode: "LA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/la.svg"
    },
    {
        name: "Latvia",
        dialCode: "+371",
        isoCode: "LV",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lv.svg"
    },
    {
        name: "Lebanon",
        dialCode: "+961",
        isoCode: "LB",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lb.svg"
    },
    {
        name: "Lesotho",
        dialCode: "+266",
        isoCode: "LS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ls.svg"
    },
    {
        name: "Liberia",
        dialCode: "+231",
        isoCode: "LR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lr.svg"
    },
    {
        name: "Libya",
        dialCode: "+218",
        isoCode: "LY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ly.svg"
    },
    {
        name: "Liechtenstein",
        dialCode: "+423",
        isoCode: "LI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/li.svg"
    },
    {
        name: "Lithuania",
        dialCode: "+370",
        isoCode: "LT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lt.svg"
    },
    {
        name: "Luxembourg",
        dialCode: "+352",
        isoCode: "LU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lu.svg"
    },
    {
        name: "Macau",
        dialCode: "+853",
        isoCode: "MO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mo.svg"
    },
    {
        name: "Madagascar",
        dialCode: "+261",
        isoCode: "MG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mg.svg"
    },
    {
        name: "Malawi",
        dialCode: "+265",
        isoCode: "MW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mw.svg"
    },
    {
        name: "Malaysia",
        dialCode: "+60",
        isoCode: "MY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/my.svg"
    },
    {
        name: "Maldives",
        dialCode: "+960",
        isoCode: "MV",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mv.svg"
    },
    {
        name: "Mali",
        dialCode: "+223",
        isoCode: "ML",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ml.svg"
    },
    {
        name: "Malta",
        dialCode: "+356",
        isoCode: "MT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mt.svg"
    },
    {
        name: "Marshall Islands",
        dialCode: "+692",
        isoCode: "MH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mh.svg"
    },
    {
        name: "Martinique",
        dialCode: "+596",
        isoCode: "MQ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mq.svg"
    },
    {
        name: "Mauritania",
        dialCode: "+222",
        isoCode: "MR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mr.svg"
    },
    {
        name: "Mauritius",
        dialCode: "+230",
        isoCode: "MU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mu.svg"
    },
    {
        name: "Mayotte",
        dialCode: "+262",
        isoCode: "YT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/yt.svg"
    },
    {
        name: "Mexico",
        dialCode: "+52",
        isoCode: "MX",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mx.svg"
    },
    {
        name: "Micronesia, Federated States of Micronesia",
        dialCode: "+691",
        isoCode: "FM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/fm.svg"
    },
    {
        name: "Moldova",
        dialCode: "+373",
        isoCode: "MD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/md.svg"
    },
    {
        name: "Monaco",
        dialCode: "+377",
        isoCode: "MC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mc.svg"
    },
    {
        name: "Mongolia",
        dialCode: "+976",
        isoCode: "MN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mn.svg"
    },
    {
        name: "Montenegro",
        dialCode: "+382",
        isoCode: "ME",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/me.svg"
    },
    {
        name: "Montserrat",
        dialCode: "+1664",
        isoCode: "MS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ms.svg"
    },
    {
        name: "Morocco",
        dialCode: "+212",
        isoCode: "MA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ma.svg"
    },
    {
        name: "Mozambique",
        dialCode: "+258",
        isoCode: "MZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mz.svg"
    },
    {
        name: "Myanmar",
        dialCode: "+95",
        isoCode: "MM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mm.svg"
    },
    {
        name: "Namibia",
        dialCode: "+264",
        isoCode: "NA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/na.svg"
    },
    {
        name: "Nauru",
        dialCode: "+674",
        isoCode: "NR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nr.svg"
    },
    {
        name: "Nepal",
        dialCode: "+977",
        isoCode: "NP",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/np.svg"
    },
    {
        name: "Netherlands",
        dialCode: "+31",
        isoCode: "NL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nl.svg"
    },
    {
        name: "Netherlands Antilles",
        dialCode: "+599",
        isoCode: "AN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/an.svg"
    },
    {
        name: "New Caledonia",
        dialCode: "+687",
        isoCode: "NC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nc.svg"
    },
    {
        name: "New Zealand",
        dialCode: "+64",
        isoCode: "NZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nz.svg"
    },
    {
        name: "Nicaragua",
        dialCode: "+505",
        isoCode: "NI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ni.svg"
    },
    {
        name: "Niger",
        dialCode: "+227",
        isoCode: "NE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ne.svg"
    },
    {
        name: "Nigeria",
        dialCode: "+234",
        isoCode: "NG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ng.svg"
    },
    {
        name: "Niue",
        dialCode: "+683",
        isoCode: "NU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nu.svg"
    },
    {
        name: "Norfolk Island",
        dialCode: "+672",
        isoCode: "NF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/nf.svg"
    },
    {
        name: "North Macedonia",
        dialCode: "+389",
        isoCode: "MK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mk.svg"
    },
    {
        name: "Northern Mariana Islands",
        dialCode: "+1670",
        isoCode: "MP",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mp.svg"
    },
    {
        name: "Norway",
        dialCode: "+47",
        isoCode: "NO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/no.svg"
    },
    {
        name: "Oman",
        dialCode: "+968",
        isoCode: "OM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/om.svg"
    },
    {
        name: "Pakistan",
        dialCode: "+92",
        isoCode: "PK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pk.svg"
    },
    {
        name: "Palau",
        dialCode: "+680",
        isoCode: "PW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pw.svg"
    },
    {
        name: "Palestine",
        dialCode: "+970",
        isoCode: "PS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ps.svg"
    },
    {
        name: "Panama",
        dialCode: "+507",
        isoCode: "PA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pa.svg"
    },
    {
        name: "Papua New Guinea",
        dialCode: "+675",
        isoCode: "PG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pg.svg"
    },
    {
        name: "Paraguay",
        dialCode: "+595",
        isoCode: "PY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/py.svg"
    },
    {
        name: "Peru",
        dialCode: "+51",
        isoCode: "PE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pe.svg"
    },
    {
        name: "Philippines",
        dialCode: "+63",
        isoCode: "PH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ph.svg"
    },
    {
        name: "Pitcairn",
        dialCode: "+872",
        isoCode: "PN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pn.svg"
    },
    {
        name: "Poland",
        dialCode: "+48",
        isoCode: "PL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pl.svg"
    },
    {
        name: "Portugal",
        dialCode: "+351",
        isoCode: "PT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pt.svg"
    },
    {
        name: "Puerto Rico",
        dialCode: "+1939",
        isoCode: "PR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pr.svg"
    },
    {
        name: "Qatar",
        dialCode: "+974",
        isoCode: "QA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/qa.svg"
    },
    {
        name: "Reunion",
        dialCode: "+262",
        isoCode: "RE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/re.svg"
    },
    {
        name: "Romania",
        dialCode: "+40",
        isoCode: "RO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ro.svg"
    },
    {
        name: "Russia",
        dialCode: "+7",
        isoCode: "RU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ru.svg"
    },
    {
        name: "Rwanda",
        dialCode: "+250",
        isoCode: "RW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/rw.svg"
    },
    {
        name: "Saint Barthelemy",
        dialCode: "+590",
        isoCode: "BL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/bl.svg"
    },
    {
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        dialCode: "+290",
        isoCode: "SH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sh.svg"
    },
    {
        name: "Saint Kitts and Nevis",
        dialCode: "+1869",
        isoCode: "KN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/kn.svg"
    },
    {
        name: "Saint Lucia",
        dialCode: "+1758",
        isoCode: "LC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lc.svg"
    },
    {
        name: "Saint Martin",
        dialCode: "+590",
        isoCode: "MF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/mf.svg"
    },
    {
        name: "Saint Pierre and Miquelon",
        dialCode: "+508",
        isoCode: "PM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/pm.svg"
    },
    {
        name: "Saint Vincent and the Grenadines",
        dialCode: "+1784",
        isoCode: "VC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/vc.svg"
    },
    {
        name: "Samoa",
        dialCode: "+685",
        isoCode: "WS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ws.svg"
    },
    {
        name: "San Marino",
        dialCode: "+378",
        isoCode: "SM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sm.svg"
    },
    {
        name: "Sao Tome and Principe",
        dialCode: "+239",
        isoCode: "ST",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/st.svg"
    },
    {
        name: "Saudi Arabia",
        dialCode: "+966",
        isoCode: "SA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sa.svg"
    },
    {
        name: "Senegal",
        dialCode: "+221",
        isoCode: "SN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sn.svg"
    },
    {
        name: "Serbia",
        dialCode: "+381",
        isoCode: "RS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/rs.svg"
    },
    {
        name: "Seychelles",
        dialCode: "+248",
        isoCode: "SC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sc.svg"
    },
    {
        name: "Sierra Leone",
        dialCode: "+232",
        isoCode: "SL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sl.svg"
    },
    {
        name: "Singapore",
        dialCode: "+65",
        isoCode: "SG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sg.svg"
    },
    {
        name: "Sint Maarten",
        dialCode: "+1721",
        isoCode: "SX",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sx.svg"
    },
    {
        name: "Slovakia",
        dialCode: "+421",
        isoCode: "SK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sk.svg"
    },
    {
        name: "Slovenia",
        dialCode: "+386",
        isoCode: "SI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/si.svg"
    },
    {
        name: "Solomon Islands",
        dialCode: "+677",
        isoCode: "SB",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sb.svg"
    },
    {
        name: "Somalia",
        dialCode: "+252",
        isoCode: "SO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/so.svg"
    },
    {
        name: "South Africa",
        dialCode: "+27",
        isoCode: "ZA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/za.svg"
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        dialCode: "+500",
        isoCode: "GS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gs.svg"
    },
    {
        name: "South Sudan",
        dialCode: "+211",
        isoCode: "SS",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ss.svg"
    },
    {
        name: "Spain",
        dialCode: "+34",
        isoCode: "ES",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/es.svg"
    },
    {
        name: "Sri Lanka",
        dialCode: "+94",
        isoCode: "LK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/lk.svg"
    },
    {
        name: "Sudan",
        dialCode: "+249",
        isoCode: "SD",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sd.svg"
    },
    {
        name: "Suriname",
        dialCode: "+597",
        isoCode: "SR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sr.svg"
    },
    {
        name: "Svalbard and Jan Mayen",
        dialCode: "+47",
        isoCode: "SJ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sj.svg"
    },
    {
        name: "Sweden",
        dialCode: "+46",
        isoCode: "SE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/se.svg"
    },
    {
        name: "Switzerland",
        dialCode: "+41",
        isoCode: "CH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ch.svg"
    },
    {
        name: "Syrian Arab Republic",
        dialCode: "+963",
        isoCode: "SY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/sy.svg"
    },
    {
        name: "Taiwan",
        dialCode: "+886",
        isoCode: "TW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tw.svg"
    },
    {
        name: "Tajikistan",
        dialCode: "+992",
        isoCode: "TJ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tj.svg"
    },
    {
        name: "Tanzania, United Republic of Tanzania",
        dialCode: "+255",
        isoCode: "TZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tz.svg"
    },
    {
        name: "Thailand",
        dialCode: "+66",
        isoCode: "TH",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/th.svg"
    },
    {
        name: "Timor-Leste",
        dialCode: "+670",
        isoCode: "TL",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tl.svg"
    },
    {
        name: "Togo",
        dialCode: "+228",
        isoCode: "TG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tg.svg"
    },
    {
        name: "Tokelau",
        dialCode: "+690",
        isoCode: "TK",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tk.svg"
    },
    {
        name: "Tonga",
        dialCode: "+676",
        isoCode: "TO",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/to.svg"
    },
    {
        name: "Trinidad and Tobago",
        dialCode: "+1868",
        isoCode: "TT",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tt.svg"
    },
    {
        name: "Tunisia",
        dialCode: "+216",
        isoCode: "TN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tn.svg"
    },
    {
        name: "Turkey",
        dialCode: "+90",
        isoCode: "TR",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tr.svg"
    },
    {
        name: "Turkmenistan",
        dialCode: "+993",
        isoCode: "TM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tm.svg"
    },
    {
        name: "Turks and Caicos Islands",
        dialCode: "+1649",
        isoCode: "TC",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tc.svg"
    },
    {
        name: "Tuvalu",
        dialCode: "+688",
        isoCode: "TV",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/tv.svg"
    },
    {
        name: "Uganda",
        dialCode: "+256",
        isoCode: "UG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ug.svg"
    },
    {
        name: "Ukraine",
        dialCode: "+380",
        isoCode: "UA",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ua.svg"
    },
    {
        name: "United Arab Emirates",
        dialCode: "+971",
        isoCode: "AE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ae.svg"
    },
    {
        name: "United Kingdom",
        dialCode: "+44",
        isoCode: "GB",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/gb.svg"
    },
    {
        name: "United States",
        dialCode: "+1",
        isoCode: "US",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/us.svg"
    },
    {
        name: "United States Minor Outlying Islands",
        dialCode: "+246",
        isoCode: "UMI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/umi.svg"
    },
    {
        name: "Uruguay",
        dialCode: "+598",
        isoCode: "UY",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/uy.svg"
    },
    {
        name: "Uzbekistan",
        dialCode: "+998",
        isoCode: "UZ",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/uz.svg"
    },
    {
        name: "Vanuatu",
        dialCode: "+678",
        isoCode: "VU",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/vu.svg"
    },
    {
        name: "Venezuela, Bolivarian Republic of Venezuela",
        dialCode: "+58",
        isoCode: "VE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ve.svg"
    },
    {
        name: "Vietnam",
        dialCode: "+84",
        isoCode: "VN",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/vn.svg"
    },
    {
        name: "Virgin Islands, British",
        dialCode: "+1284",
        isoCode: "VG",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/vg.svg"
    },
    {
        name: "Virgin Islands, U.S.",
        dialCode: "+1340",
        isoCode: "VI",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/vi.svg"
    },
    {
        name: "Wallis and Futuna",
        dialCode: "+681",
        isoCode: "WF",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/wf.svg"
    },
    {
        name: "Yemen",
        dialCode: "+967",
        isoCode: "YE",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/ye.svg"
    },
    {
        name: "Zambia",
        dialCode: "+260",
        isoCode: "ZM",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/zm.svg"
    },
    {
        name: "Zimbabwe",
        dialCode: "+263",
        isoCode: "ZW",
        flag: "https://cdn.kcak11.com/CountryFlags/countries/zw.svg"
    }
  ]
 
  export const svgIcon = {
    "edit":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M20.5 6.5L7 20H2v-5L15.5 1.5l5 5zm-7.823.651L4 15.828V18h2.172l8.677-8.677-2.172-2.172zm3.586.758L17.672 6.5 15.5 4.328l-1.409 1.41 2.172 2.17z" fillRule="evenodd"></path></svg>,
    "delete":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M8 2h6v2h5v2h-1v11a3 3 0 01-3 3H7a3 3 0 01-3-3V6H3V4h5V2zM6 6v11a1 1 0 001 1h8a1 1 0 001-1V6H6zm4 2v8H8V8h2zm4 0v8h-2V8h2z" fillRule="evenodd"></path></svg>,
    "copy":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M2 16V2h14v4h4v14H6v-4H2zM4 4h10v10H4V4zm4 12v2h10V8h-2v8H8z" fillRule="evenodd"></path></svg>,
    "up":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M4 12.75V10l7-7 7 7v2.75l-6-6V19h-2V6.75l-6 6z"></path></svg>,
    "down":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M18 9.25V12l-7 7-7-7V9.25l6 6V3h2v12.25l6-6z"></path></svg>,
    "strike":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M10 18h2v-6h-2v6zM3 11v-1h7V6H5V4h12v2h-5v4h7v1H3z"></path></svg>,
    "move":<svg fill="currentColor" height="50" viewBox="0 -960 960 960" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path xmlns="http://www.w3.org/2000/svg" d="M480-80 310-250l57-57 73 73v-206H235l73 72-58 58L80-480l169-169 57 57-72 72h206v-206l-73 73-57-57 170-170 170 170-57 57-73-73v206h205l-73-72 58-58 170 170-170 170-57-57 73-73H520v205l72-73 58 58L480-80Z"/></svg>,
    "bold":<svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 22 22" width="50" className="svgicon"><path clipRule="evenodd" d="M5 4h6.5a4 4 0 013.42 6.076A4.5 4.5 0 0112 18H5V4zm3 3h3.5a1 1 0 110 2H8V7zm0 5v3h4a1.5 1.5 0 000-3H8z" fillRule="evenodd"></path></svg>,
    "italic":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 22 22" width="50" className="svgicon"><path d="M13.429 6L10.57 16H13v2H6v-2h2.571L11.43 6H9V4h7v2h-2.571z" id="yui_3_17_2_1_1703571306743_7099"></path></svg>,
    "underline":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M200-120v-80h560v80H200Zm280-160q-101 0-157-63t-56-167v-330h103v336q0 56 28 91t82 35q54 0 82-35t28-91v-336h103v330q0 104-56 167t-157 63Z"/></svg>,
    "link":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z"/></svg>,
    "unlink":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="m770-302-60-62q40-11 65-42.5t25-73.5q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 57-29.5 105T770-302ZM634-440l-80-80h86v80h-6ZM792-56 56-792l56-56 736 736-56 56ZM440-280H280q-83 0-141.5-58.5T80-480q0-69 42-123t108-71l74 74h-24q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h65l79 80H320Z"/></svg>,
    "ai":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M12 0h-1L5 14h5v8h1l6-14h-5V0z"></path></svg>,
    "redo":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M396-200q-97 0-166.5-63T160-420q0-94 69.5-157T396-640h252L544-744l56-56 200 200-200 200-56-56 104-104H396q-63 0-109.5 40T240-420q0 60 46.5 100T396-280h284v80H396Z"/></svg>,
    "undo":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path xmlns="http://www.w3.org/2000/svg" d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z"/></svg>,
    "drag":<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z"/></svg>,
    "rename":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5368 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z" fill="#5F6368"/> </svg>,
    "links":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M10.8077 16.5384H7.0385C5.78283 16.5384 4.7125 16.0959 3.8275 15.2109C2.9425 14.3261 2.5 13.2559 2.5 12.0004C2.5 10.7449 2.9425 9.67459 3.8275 8.78943C4.7125 7.90409 5.78283 7.46143 7.0385 7.46143H10.8077V8.96143H7.0385C6.19867 8.96143 5.48233 9.25792 4.8895 9.85092C4.2965 10.4439 4 11.1603 4 11.9999C4 12.8396 4.2965 13.5559 4.8895 14.1489C5.48233 14.7419 6.19867 15.0384 7.0385 15.0384H10.8077V16.5384ZM8.25 12.7499V11.2499H15.75V12.7499H8.25ZM13.1923 16.5384V15.0384H16.9615C17.8013 15.0384 18.5177 14.7419 19.1105 14.1489C19.7035 13.5559 20 12.8396 20 11.9999C20 11.1603 19.7035 10.4439 19.1105 9.85092C18.5177 9.25792 17.8013 8.96143 16.9615 8.96143H13.1923V7.46143H16.9615C18.2172 7.46143 19.2875 7.90393 20.1725 8.78893C21.0575 9.67376 21.5 10.7439 21.5 11.9994C21.5 13.2549 21.0575 14.3253 20.1725 15.2104C19.2875 16.0958 18.2172 16.5384 16.9615 16.5384H13.1923Z" fill="#5F6368"/> </svg>,
    "addSubmenu":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.25 16.75H12.75V12.75H16.75V11.25H12.75V7.25H11.25V11.25H7.25V12.75H11.25V16.75ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19Z" fill="#5F6368"/>
    </svg>,
    "moveUp":<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5F6368"><path d="M450-180v-485.08L222.15-437.23 180-480l300-300 300 300-42.15 42.77L510-665.08V-180h-60Z"/></svg>,
    "moveDown":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.25 4.5V16.627L5.55375 10.9307L4.5 12L12 19.5L19.5 12L18.4462 10.9307L12.75 16.627V4.5H11.25Z" fill="#5F6368"/>
    </svg>,
    "moveOutside":<svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
    <path d="M0.5 6L1.56925 7.06925L5.25 3.373L5.25 14.5L16.5 14.5L16.5 13L6.75 13L6.75 3.373L10.4462 7.06925L11.5152 6.0155L6 0.5L0.5 6Z" fill="#5F6368"/>
    </svg>,
    "moveUnderTop":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"> <g id="Group_1" data-name="Group 1" transform="translate(-267 -122)"> <rect id="Rectangle_1" data-name="Rectangle 1" width="24" height="24" transform="translate(267 122)" fill="none"/> <path id="subdirectory_arrow_left_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24" d="M6.552,18.564,0,12.012,6.579,5.433,8.108,6.989,4.177,10.92H14.2V0H16.38V13.1H4.177l3.931,3.9Z" transform="translate(270 142.38) rotate(-90)" fill="#5f6368"/> </g> </svg>,
    "submenuLayout":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H11.25V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM12.75 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V12H12.75V19ZM12.75 10.5H19V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H12.75V10.5Z" fill="#5F6368"/>
    </svg>,
    "remove":<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7.30775 20.5002C6.80908 20.5002 6.38308 20.3236 6.02975 19.9705C5.67658 19.6171 5.5 19.1911 5.5 18.6925V6.00022H4.5V4.50022H9V3.61572H15V4.50022H19.5V6.00022H18.5V18.6925C18.5 19.1976 18.325 19.6252 17.975 19.9752C17.625 20.3252 17.1974 20.5002 16.6923 20.5002H7.30775ZM17 6.00022H7V18.6925C7 18.7823 7.02883 18.8561 7.0865 18.9137C7.14417 18.9714 7.21792 19.0002 7.30775 19.0002H16.6923C16.7692 19.0002 16.8398 18.9681 16.9038 18.904C16.9679 18.84 17 18.7695 17 18.6925V6.00022ZM9.404 17.0002H10.9037V8.00022H9.404V17.0002ZM13.0962 17.0002H14.596V8.00022H13.0962V17.0002Z" fill="#5F6368"/>
    </svg>
}

export const languages = [
    //{"key":"en", text:"english", "live":"en"},
    {"key":"fr", text:"french", "live":"fr"},
    {"key":"pt", text:"portuguese", "live":"pt"},
    {"key":"ar", text:"arabic", "live":"sa"},
    {"key":"es", text:"spanish", "live":"es"},
    {"key":"de", text:"german", "live":"de"},
    {"key":"it", text:"italian", "live":"it"},
    {"key":"ja", text:"japanese", "live":"jp"},
    {"key":"ru", text:"russian", "live":"ru"}, 
    {"key":"nl", text:"dutch", "live":"nl"},
    {"key":"zh", text:"chinese", "live":"cn"} 
]

export const template_categories = [
    "portfolio",
    "wordpress",
    "blog",
    "news",
    "landing pages",
    "ecommerce",
    "design",
    "magazine",
    "wedding",
    "books",
    "business",
    "app",
    "law",
    "legal",
    "music",
    "automotive",
    "fashion",
    "gaming",
    "art",
    "food",
    "digital marketing",
    "real estate",
    "architecture",
    "events",
    "online store",
    "research",
    "sports",
    "travel",
    "animals",
    "education",
    "podcast",
    "restaurant",
    "spa",
    "crafts",
    "finance",
    "furniture",
    "interior design",
    "photography",
    "construction",
    "film",
    "human resources",
    "medical",
    "science",
    "technology",
    "tv",
    "recruitment",
    "salon",
    "fitness",
    "gardening",
    "online courses",
    "worship",
    "freelancer",
    "health",
    "social networking",
    "transportation",
    "agriculture",
    "beauty",
    "investment",
    "non-profit",
    "personal",
    "radio",
    "tourism",
    "environmental",
    "healthcare",
    "location",
    "pets",
    "charity",
    "community",
    "electronics",
    "helpdesk",
    "religion",
    "religious",
    "industrial",
    "manufacturing",
    "dating",
    "spiritual",
    "government",
    "customer support",
    "entertainment",
    "gadgets",
    "literature",
    "celebrations",
    "consulting services",
    "crowdfunding",
    "hobbies",
    "municipal",
    "others",
    "places",
    "startups",
    "virtual events",
    "workshops"
]

export const submenuColors = [
    {"key":"customMenu", "value":false},

    {"key":"submenuTextColor", "value":"#000000"},
    {"key":"submenuBackgroundType", "value":"color"},
    {"key":"submenuBackground", "value":"#FFFFFFFF"},

    {"key":"submenuTextColorHover", "value":"#000000"},
    {"key":"submenuBackgroundHoverType", "value":"color"},
    {"key":"submenuBackgroundHover", "value":"#FFFFFFFF"},

    {"key":"submenuTextColorClick", "value":"#000000"},
    {"key":"submenuBackgroundClickType", "value":"color"},
    {"key":"submenuBackgroundClick", "value":"#FFFFFFFF"}
]

export const tagType = [
    //{"key":"", "text":"none"},
    {"key":"h1", "text":"heading"},
    {"key":"h2", "text":"heading"},
    {"key":"h3", "text":"heading"},
    {"key":"h4", "text":"heading"},
    {"key":"h5", "text":"heading"},
    {"key":"h6", "text":"heading"},
    //{"key":"p", "text":"paragraph"}
]